import { useEffect } from 'react';

import { useAuth } from '@/lib/context/auth-context';

import { forgetResumeDecision } from '../state/resumeDecision';
import { browserTabStorage } from '../state/session';

/** Signed out, by choice or by an expired session: the next sign-in asks again whether to continue. Renders nothing. */
export function ForgetResumeDecisionWhenSignedOut() {
  const { isAuthenticated, isLoading } = useAuth();
  useEffect(() => {
    if (!isLoading && !isAuthenticated) forgetResumeDecision(browserTabStorage());
  }, [isAuthenticated, isLoading]);
  return null;
}
